import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).summernote({
      height: 140,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol']],
        ['insert', ['link']]
      ]
    })
  }

  disconnect() {
    if ($(this.element).data('summernote')) {
      $(this.element).summernote('destroy')
    }
  }
}
